var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getLocationId, toCamelCaseData } from "@common/utils";
import http, { Q } from "@http";
import Cookies from "js-cookie";
import { observable, action, computed, runInAction } from "mobx";
var HomeStore = /** @class */ (function () {
    function HomeStore() {
        this.currentUser = {};
        this.nextScheduledData = null;
        this.notScheduledWoData = [];
        this.scheduledWoData = [];
        this.completedWoData = [];
    }
    Object.defineProperty(HomeStore.prototype, "getGreetingText", {
        get: function () {
            var date = new Date();
            if (date.getHours() >= 5 && date.getHours() < 12) {
                return "Good morning";
            }
            if (date.getHours() >= 12 && date.getHours() < 17) {
                return "Good afternoon";
            }
            return "Good evening";
        },
        enumerable: false,
        configurable: true
    });
    HomeStore.prototype.getCurrentUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        runInAction(function () {
                            Cookies.set("userId", user.UserId);
                            Cookies.set("userName", user.UserName);
                            Cookies.set("residentId", user === null || user === void 0 ? void 0 : user.ResidentId);
                            _this.currentUser = toCamelCaseData(user);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeStore.prototype.getNextScheduledWo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getNextScheduledWo({
                            locationId: getLocationId(),
                            userId: Cookies.get('userId')
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data && data.isSuccess === true) {
                                _this.nextScheduledData = toCamelCaseData(data.body);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeStore.prototype.getNotScheduledWoList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getNotScheduledWoList({
                            locationId: getLocationId(),
                            userId: Cookies.get('userId'),
                            pageSize: 3
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data && data.isSuccess == true) {
                                _this.notScheduledWoData = toCamelCaseData(data.body);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeStore.prototype.getScheduledWoList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getScheduledWoList({
                            locationId: getLocationId(),
                            userId: Cookies.get('userId'),
                            pageSize: 3
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data && data.isSuccess === true) {
                                _this.scheduledWoData = toCamelCaseData(data.body);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeStore.prototype.getCompletedWoList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getCompletedWoList({
                            locationId: getLocationId(),
                            userId: Cookies.get('userId'),
                            pageSize: 3
                        })];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (data && data.isSuccess === true) {
                                _this.completedWoData = toCamelCaseData(data.body);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomeStore.prototype.api = function () {
        return {
            getCurrentUser: function () {
                return Q(http.get("/rsp/dashboard/getcurrentuser"));
            },
            getNextScheduledWo: function (params) {
                return Q(http.get("/RSP/Schedule/GetNextScheduledWo", { params: params }));
            },
            getNotScheduledWoList: function (params) {
                return Q(http.get("/RSP/Schedule/GetNotScheduledWoList", { params: params }));
            },
            getScheduledWoList: function (params) {
                return Q(http.get("/RSP/Schedule/GetScheduledWoList", { params: params }));
            },
            getCompletedWoList: function (params) {
                return Q(http.get("/RSP/Schedule/GetCompletedWoList", { params: params }));
            },
        };
    };
    __decorate([
        observable
    ], HomeStore.prototype, "currentUser", void 0);
    __decorate([
        observable
    ], HomeStore.prototype, "nextScheduledData", void 0);
    __decorate([
        observable
    ], HomeStore.prototype, "notScheduledWoData", void 0);
    __decorate([
        observable
    ], HomeStore.prototype, "scheduledWoData", void 0);
    __decorate([
        observable
    ], HomeStore.prototype, "completedWoData", void 0);
    __decorate([
        computed
    ], HomeStore.prototype, "getGreetingText", null);
    __decorate([
        action.bound
    ], HomeStore.prototype, "getCurrentUser", null);
    __decorate([
        action.bound
    ], HomeStore.prototype, "getNextScheduledWo", null);
    __decorate([
        action.bound
    ], HomeStore.prototype, "getNotScheduledWoList", null);
    __decorate([
        action.bound
    ], HomeStore.prototype, "getScheduledWoList", null);
    __decorate([
        action.bound
    ], HomeStore.prototype, "getCompletedWoList", null);
    return HomeStore;
}());
export default HomeStore;
